



































































































































































































































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import {
  CustomersApi,
  LocationsApi,
  UserModel,
  ShipmentCertificateModel,
  TreatmentRequestsApi,
  ShipmentCertificatesApi,
  PutShipmentCertificateRequest,
  PostShipmentCertificateRequest,
  GetShipmentCertificateResponse,
} from "../../../apis";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { AxiosResponse } from "axios";
import VueI18n from "vue-i18n";
import { min, max } from 'lodash';
import { ACTION as ACTION_SHIPMENT_REQUEST, ISSUE_DATE_SUGGESTION, STATUS } from "./index";
import ConfirmDialog from "../../components/user-management/ConfirmDialog.vue";
import ShipmentConfirmDialog from "./ShipmentConfirmDialog.vue";
import IssueDateSuggestionDialog from './IssueDateSuggestionDialog.vue';
import moment from "moment";
enum ACTION {
  ADD = "ADD",
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export interface TreatmentRequestOption {
  treatmentNumber: number;
  treatmentId: string;
  treatmentStart: string;
  treatmentEnd: string;
  product: string;
  productName: string;
  isPallet: boolean;
  freeTimes: number;
  expiryDate?: string;
}

@Component({
  components: { ValidationProvider, ValidationObserver, ConfirmDialog, IssueDateSuggestionDialog, ShipmentConfirmDialog },
})
export default class ShipmentCertificateForm extends Vue {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  requestWeightOrigin = 0;
  shipmentCertificate = {} as ShipmentCertificateModel;
  shipmentReq = {
    totalUncertificatedWeight: 0,
    remainingWeight: 0,
    treatmentRequests: [],
    fee: "Not Free",
  } as PutShipmentCertificateRequest | PostShipmentCertificateRequest;
  feeOptions = [
    { value: "Free", label: this.$t("text.free") },
    { value: "Not Free", label: this.$t("text.notFree") },
  ];
  currentMode: ACTION = null;
  selectedID: string = "";
  isViewMode = false;
  isEditMode = false;
  isNewMode = false;
  readonly NEW = ACTION.ADD;
  readonly EDIT = ACTION.EDIT;
  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;
  showShipmentConfirmDialog = false;
  selectedAction: ACTION_SHIPMENT_REQUEST = null;
  showViewTreatmentBlock = false;
  intervalId: any = null;
  products = [];
  confirmIssueDateSuggestionDialogContent: string | VueI18n.TranslateResult = "";
  desiredIssueDateFrm = "";
  currentStatus: string = null; //VALID
  remarkDialog: string = "";
  isSubmitting = false;

  created() {
    this.currentMode = this.$route.meta.mode as ACTION;
    if (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) {
      this.selectedID = this.$route.params.id;
    }
    this.isViewMode = this.currentMode === ACTION.VIEW;
    this.isEditMode = this.currentMode === ACTION.EDIT;
    this.isNewMode = this.currentMode === ACTION.ADD;
    this.initForm();
  }

  async initForm() {
    await this.getLocations();
    if (this.selectedID) {
      await this.getShipmentById(this.selectedID);
    }
  }

  get isClient() {
    return this.$util.isClient();
  }

  get minDesiredIssueDateLimit(): string {
    if (!this.shipmentReq.treatmentRequests || this.shipmentReq.treatmentRequests.length === 0) return "";
    const endDateArr = this.treatmentOptions
      .filter((val) => this.shipmentReq.treatmentRequests.includes(val.treatmentId))
      .map((val) => val.treatmentEnd)
      .filter(Boolean);
    if (endDateArr.length === 0) return "";
    return moment(max(endDateArr)).format("YYYY-MM-DD");
  }

  get maxDesiredIssueDateLimit(): string {
    const todayStr = moment().format("YYYY-MM-DD");
    if (!this.shipmentReq.treatmentRequests || this.shipmentReq.treatmentRequests.length === 0) {
      return todayStr;
    }
    const dates = this.treatmentOptions
      .filter(t => this.shipmentReq.treatmentRequests.includes(t.treatmentId))
      .map(t => t.expiryDate)
      .filter(Boolean);
    
    if (dates.length > 0) {
      const minExpiryStr = moment(min(dates)).format("YYYY-MM-DD");
      return minExpiryStr < todayStr ? minExpiryStr : todayStr;
    }
    return todayStr;
  }

  async getShipmentById(selectedID) {
    let res: AxiosResponse<GetShipmentCertificateResponse | any>;
    try {
      this.$util.showLoading();
      res = await new ShipmentCertificatesApi().getShipmentCertificate({
        id: selectedID,
      });
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }

    const data = res.data.data;
    this.shipmentCertificate = data as ShipmentCertificateModel;
    this.requestWeightOrigin = data.requestWeight;
    if (!this.$util.isClient()) {
      // build options in mode VIEW
      this.locationOptions = [data.location];
      this.productOptions = [
        { value: data.product.id, text: data.product.treatmentName },
      ];
    }
    this.products = data.requestWeights;
    this.desiredIssueDateFrm = data.desiredIssueDate ? moment(data.desiredIssueDate).format("YYYY-MM-DD") : "";
    this.currentStatus = data.status;
    this.shipmentReq = {
      ...Object.assign({}, data),
      location: data.location.id,
      product: data.product.id,
      statusTrans: this.$t(
        `status.${data.status.replace(/\s/g, "").toUpperCase()}`
      ),
    };
    await Promise.all([this.getProducts(), this.onChangeProduct(false)]);
  }

  get addShipmentClick() {
    return this.$store.getters.addShipmentClick;
  }

  get previewShipmentClick() {
    return this.$store.getters.previewShipmentClick;
  }

  get previewClientShipmentClick() {
    return this.$store.getters.previewClientShipmentClick;
  }

  get approveShipmentClick() {
    return this.$store.getters.approveShipmentClick;
  }

  get rejectShipmentClick() {
    return this.$store.getters.rejectShipmentClick;
  }

  onCancelAdd() {
    return this.$router.push({ name: "shipment" });
  }

  @Watch("addShipmentClick")
  async onSubmit() {
    // Prevent multiple simultaneous submissions
    if (this.isSubmitting) {
      return;
    }

    const valid = await this.observer.validate();

    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    const isRequestInput = this.products.find(p=> !!p.requestWeight && p.requestWeight != "0");
    if (!isRequestInput){
      this.$util.showError('noRequestRequired');
      return;
    }
    this.checkExpiryLimit();
    if (this.desiredIssueDateErrors.length > 0) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    if (this.isNewMode) {
      const body = this.requestBuilder();
      const data = await new ShipmentCertificatesApi().getMaximumIssueDate({
        postShipmentCertificateRequest: body as PostShipmentCertificateRequest
      });
      this.maxDesiredIssueDate = data.data.maximumShipmentIssueDate;
      this.minDesiredIssueDate = data.data.minimumShipmentIssueDate;
    }
    const isValidMinDesiredIssueDate = await this.isValidMinimumDesiredIssueDate();
    if (!isValidMinDesiredIssueDate) {
      this.desiredIssueDateErrors = [this.lodash.template(
        `${this.$t("shipmentCertificateForm.minDesiredIssueDate")}`
      )({ minDate: this.$moment(this.minDesiredIssueDate).format("DD-MM-YYYY") })];
      return;
    }
    const isValidDesiredIssueDate = await this.isValidMaximumDesiredIssueDate();
    if (!isValidDesiredIssueDate) {
      this.desiredIssueDateErrors = [this.lodash.template(
        `${this.$t("shipmentCertificateForm.maxDesiredIssueDate")}`
      )({ maxDate: this.$moment(this.maxDesiredIssueDate).format("DD-MM-YYYY") })];
      return;
    }
    this.desiredIssueDateErrors = [];
    if (this.isEditMode) {
      this.isSubmitting = true;
      try {
        await this.doSubmit()
          .then((res) => this.handleSuccess())
          .catch((err) => this.handleFailed(err));
      } finally {
        this.isSubmitting = false;
      }
      return;
    }
    for (const product of this.products) {
      if (product.inValidWeight !== product.inValidWeightBak) {
        await this.onOpenIssueDateSuggestionDialog();
        return;
      }
    }
    this.isSubmitting = true;
    try {
      await this.doSubmit()
        .then((res) => this.handleSuccess())
        .catch((err) => this.handleFailed(err));
    } finally {
      this.isSubmitting = false;
    }
    return;
  }

  checkExpiryLimit() {
    if (!this.desiredIssueDateFrm) {
      this.desiredIssueDateErrors = [];
      return;
    }

    const dateStr = moment(this.desiredIssueDateFrm).format("YYYY-MM-DD");
    const todayStr = moment().format("YYYY-MM-DD");

    if (dateStr > todayStr) {
      this.desiredIssueDateErrors = [
        this.$t("shipmentCertificateForm.futureDateLimitExceeded").toString()
      ];
      return;
    }

    if (this.maxDesiredIssueDateLimit && dateStr > this.maxDesiredIssueDateLimit) {
      this.desiredIssueDateErrors = [
        this.lodash.template(
          `${this.$t("shipmentCertificateForm.expiryDateLimitExceeded")}`
        )({ maxDate: moment(this.maxDesiredIssueDateLimit).format("DD-MM-YYYY") })
      ];
      return;
    }

    if (this.minDesiredIssueDateLimit && dateStr < this.minDesiredIssueDateLimit) {
      this.desiredIssueDateErrors = [
        this.lodash.template(
          `${this.$t("shipmentCertificateForm.endDateLimitExceeded")}`
        )({ minDate: moment(this.minDesiredIssueDateLimit).format("DD-MM-YYYY") })
      ];
      return;
    }

    this.desiredIssueDateErrors = [];
  }

  @Watch("desiredIssueDateFrm")
  onDesiredIssueDateFrmChanged() {
    this.checkExpiryLimit();
  }

  @Watch("minDesiredIssueDateLimit")
  onMinDesiredIssueDateLimitChanged() {
    this.checkExpiryLimit();
  }

  @Watch("maxDesiredIssueDateLimit")
  onMaxDesiredIssueDateLimitChanged() {
    this.checkExpiryLimit();
  }

  maxDesiredIssueDate: string;
  minDesiredIssueDate: string;
  async isValidMaximumDesiredIssueDate(): Promise<Boolean> {
    const body = this.shipmentReq as PostShipmentCertificateRequest;
    if (!this.isNewMode) {
      this.maxDesiredIssueDate = body.maximumIssueDate;
    }
    return Promise.resolve(!(this.$moment(this.desiredIssueDateFrm).isAfter(this.$moment(this.maxDesiredIssueDate).endOf('day'))));
  }
  async isValidMinimumDesiredIssueDate(): Promise<Boolean> {
    const body = this.shipmentReq as PostShipmentCertificateRequest;
    if (!this.isNewMode) {
      this.minDesiredIssueDate = body.minimumIssueDate;
    }
    if (this.minDesiredIssueDate){
      return Promise.resolve(!(this.$moment(this.minDesiredIssueDate).startOf('day').isAfter(this.$moment(this.desiredIssueDateFrm))));
    } else return true;
  }

  issueSuggestDate: string;
  desiredIssueDate: string = "";
  desiredIssueDateErrors: VueI18n.TranslateResult[] = [];
  showIssueDateSuggestionDialog = false;
  async onOpenIssueDateSuggestionDialog() {
    // this.clearInterval();
    const body = this.requestBuilder();
    try {
      this.$util.showLoading();
      const res = await new ShipmentCertificatesApi().getIssueSuggestDate({
        postShipmentCertificateRequest: body as PostShipmentCertificateRequest
      });
      this.issueSuggestDate = res.data.issueSuggestDate;
      this.confirmIssueDateSuggestionDialogContent = `Your shipment certificate request
      is using remaining weight from an expired treatment.
      However, you can get a new certificate with the following
      suggested issue date: <br/><b>${this.$moment(this.issueSuggestDate).format("DD MMM, YYYY")}</b>`;
      this.showIssueDateSuggestionDialog = true;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onCloseIssueDateSuggestionDialog() {
    this.showIssueDateSuggestionDialog = false;
    // this.setIntervalGetTotalUncertificatedWeight();
  }

  async handleActionIssueDateSuggestion(value) {
    // Prevent multiple simultaneous submissions
    if (this.isSubmitting) {
      return;
    }
    const body = this.requestBuilder();
    switch (value) {
      case ISSUE_DATE_SUGGESTION.ACCEPT: {
        try {
          this.$util.showLoading();
          this.currentStatus = STATUS.ACCEPTED;
        } catch (error) {
          // this.$util.showError(error);
        } finally {
          this.$util.hideLoading();
        }
        this.isSubmitting = true;
        try {
          await this.doSubmit()
            .then((res) => this.handleSuccess())
            .catch((err) => this.handleFailed(err));
        } finally {
          this.isSubmitting = false;
        }
        break;
      }
      case ISSUE_DATE_SUGGESTION.NEED_SUPPORT: {
        try {
          this.$util.showLoading();
          this.currentStatus = STATUS.NEED_SUPPORT;
          } catch (error) {
            //this.$util.showError(error);
          } finally {
            this.$util.hideLoading();
          }
        this.isSubmitting = true;
        try {
          await this.doSubmit()
            .then((res) => this.handleSuccess())
            .catch((err) => this.handleFailed(err));
        } finally {
          this.isSubmitting = false;
        }
        break;
      }
      case ISSUE_DATE_SUGGESTION.REJECT: {
        this.onCloseIssueDateSuggestionDialog();
        break;
      }
      default: {
        break;
      }
    }
  }

  @Watch("previewShipmentClick")
  doPreviewShipmentClick() {
    console.log("previewShipmentClick");
  }

  @Watch("previewClientShipmentClick")
  doPreviewClientShipmentClick() {
    console.log("previewClientShipmentClick");
  }

  @Watch("approveShipmentClick")
  doApproveShipmentClick() {
    this.onApporve();
  }

  @Watch("rejectShipmentClick")
  doRejectShipmentClick() {
    this.onReject();
  }

  requestBuilder(): PutShipmentCertificateRequest | PostShipmentCertificateRequest {
    const body: PutShipmentCertificateRequest | PostShipmentCertificateRequest =
      {
        ...this.shipmentReq,
        desiredIssueDate: this.$moment(this.desiredIssueDateFrm).utc().format("YYYY-MM-DD HH:mm:ss"),
        issueSuggestDate: this.maxDesiredIssueDate ? this.$moment(this.maxDesiredIssueDate).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        maximumIssueDate: this.maxDesiredIssueDate ? this.$moment(this.maxDesiredIssueDate).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        minimumIssueDate: this.minDesiredIssueDate ? this.$moment(this.minDesiredIssueDate).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        status: this.currentStatus,
        customer: this.getCustomerIdByLocation(),
        requestWeights: this.products.map(product => {
          return {
            productName: product.productName,
            isPallet: product.isPallet,
            specification: product.specification,
            requestWeight: product.requestWeight,
            remainingWeight: product.remainingWeight,
            validWeight: product.validWeight,
            inValidWeight: product.inValidWeight,
          };
        }),
      };
    return body;
  }

  doSubmit(): Promise<AxiosResponse> {
    const body = this.requestBuilder();
    delete body.totalUncertificatedWeight;
    if (this.currentMode === ACTION.EDIT && this.selectedID) {
      return new ShipmentCertificatesApi().updateShipmentCertificate({
        id: this.selectedID,
        putShipmentCertificateRequest: body,
      });
    } else {
      return new ShipmentCertificatesApi().createShipmentCertificate({
        postShipmentCertificateRequest: body as PostShipmentCertificateRequest,
      });
    }
  }

  handleSuccess() {
    this.$router.push({ name: "shipment" });
  }

  handleFailed(err) {
    this.$util.showError(err);
  }

  get me(): UserModel {
    return this.$store.getters.user as UserModel;
  }

  getCustomerIdByLocation() {
    if (this.shipmentReq && this.shipmentReq.location) {
      const location = this.lodash.find(this.locationOptions, (l) => l.id == this.shipmentReq.location);
      return location.customerId;
    }
    return undefined;
  }

  locationOptions: any[] = [];
  async getLocations() {
    try {
      // this.$util.showLoading();
      if (this.$util.isClient()) {
        const res = await new LocationsApi().getLocationsWithCustomer({
          customerId: this.me.customerId,
        });
        this.locationOptions = res.data.data;
      } else {
        const res = await new LocationsApi().getActiveLocations();
        this.locationOptions = res.data.data;
      }
    } catch (error) {
      this.$util.showError(error);
    } finally {
      // this.$util.hideLoading();
    }
  }

  productOptions = [];
  treatmentOptions: any[] = [];
  treatmentStartDateMin = null;
  treatmentEndDateMax = null;
  treatmentStartDateMinRange = null;
  treatmentEndDateMaxRange = null;
  get treatmentNumberOptions(){
    const options =  this.treatmentOptions.filter((val)=>{
      if (val.product !=  this.shipmentReq.product) return false;
      if (this.treatmentStartDateMinRange){
        if (moment(val.treatmentStart) < moment(this.treatmentStartDateMinRange)){
          return false;
        }
      }
      if (this.treatmentEndDateMaxRange){
        if (moment(val.treatmentEnd) > moment(this.treatmentEndDateMaxRange).endOf('days')){
          return false;
        }
      }
      return true;
    }
    ).map((val) => ({
        value: val.treatmentId,
        text: val.treatmentNumber,
      }));
      if (this.shipmentReq.treatmentRequests){
        const length = this.shipmentReq.treatmentRequests.length;
        this.shipmentReq.treatmentRequests =this.shipmentReq.treatmentRequests.filter(val=>{
          return options.find(e=> e.value == val);
        });
        if (length != this.shipmentReq.treatmentRequests.length){
          this.getTotalUncertificatedWeight();
        }
      }
    return options;
  }

  async onChangetreatmentRange() {
    this.treatmentStartDateMinRange = this.treatmentStartDateMin;
    this.treatmentEndDateMaxRange = this.treatmentEndDateMax;
  }
  async onChangetreatmentNumber() {
    const startDateArr = this.treatmentOptions
      .filter((val) => this.shipmentReq.treatmentRequests.includes(
          val.treatmentId
        ))
      .map((val) => val.treatmentStart);
    if (startDateArr && startDateArr.length) {
      this.treatmentStartDateMin = moment(min(startDateArr)).format("YYYY-MM-DD");
    }
    const endDateArr = this.treatmentOptions
      .filter((val) => this.shipmentReq.treatmentRequests.includes(
          val.treatmentId
        ))
      .map((val) => val.treatmentEnd);
    if (endDateArr && endDateArr.length) {
      this.treatmentEndDateMax = moment(max(endDateArr)).format("YYYY-MM-DD");
    }
    this.getTotalUncertificatedWeight();
  }
  async getProducts() {
    if (!this.shipmentReq.location) {
      this.productOptions = [];
      this.shipmentReq.product = "";
    }
    try {
      this.$util.showLoading();
      const res =
        await new TreatmentRequestsApi().getTreatmentRequestByLocation({
          id: this.shipmentReq.location,
        });
      this.productOptions = res.data.data.map((val) => ({
        value: val.product,
        text: (val as any).productName,
      }));
      this.treatmentOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  // beforeDestroy() {
  //   this.clearInterval();
  // }

  // private clearInterval() {
  //   if (this.intervalId) {
  //     clearInterval(this.intervalId);
  //     this.intervalId = null;
  //   }
  // }

  async onChangeProduct(isReset: boolean = true) {
    // this.clearInterval();
    if (isReset) {
      this.products = [];
      this.shipmentReq.treatmentRequests = [];
      }
    this.getTotalUncertificatedWeight();
    // this.setIntervalGetTotalUncertificatedWeight();
  }

  // setIntervalGetTotalUncertificatedWeight() {
  //   this.intervalId = setInterval(() => {
  //     this.getTotalUncertificatedWeight(false);
  //   }, 30 * 1000);
  // }

  async getTotalUncertificatedWeight(loading: boolean = true) {
    if (!this.shipmentReq.location || !this.shipmentReq.product) {
      return;
    }
    if ([ACTION.EDIT, ACTION.VIEW].includes(this.currentMode)) {
      return;
    }
    try {
      if (loading) this.$util.showLoading();
      const res = await new ShipmentCertificatesApi().getWeightsProduct({
        locationId: this.shipmentReq.location,
        treatmentRequests: this.shipmentReq.treatmentRequests,
        productName: ((this.lodash.find(this.productOptions, p => p.value === this.shipmentReq.product) || {}).text || ""),
      });
      this.products = res.data.data.map((product, idx) => {
        const productNew: any = {...product};
        const productRes = {
          ...productNew,
          validWeightBak: product.validWeight,
          inValidWeightBak: product.inValidWeight
        };
        return productRes;
      });
      this.shipmentReq.totalUncertificatedWeight = Number(res.data.data);
      if (this.products.length == 0){
        // this.clearInterval();
        this.$util.showError('noRemainProduct');
      }
    } catch (error) {
      // this.$util.showError(error);
    } finally {
      if (loading) this.$util.hideLoading();
    }
  }

  onApporve() {
    this.selectedAction = ACTION_SHIPMENT_REQUEST.APPROVED;
    this.showShipmentConfirmDialog = true;
    this.confirmContent = this.lodash.template(
      `${this.$t("dialog.approve.shipmentCertificate")}`
    )({ number: this.shipmentCertificate.certificateId });
  }

  onReject() {
    this.selectedAction = ACTION_SHIPMENT_REQUEST.REJECTED;
    this.showShipmentConfirmDialog = true;
    this.confirmContent = this.lodash.template(
      `${this.$t("dialog.reject.shipmentCertificate")}`
    )({ number: this.shipmentCertificate.certificateId });
  }

  async onOkConfirmDialog(remarkDialog) {
    this.remarkDialog = remarkDialog;
    if (this.selectedAction === ACTION_SHIPMENT_REQUEST.REJECTED) {
      await this.doReject();
    }
    if (this.selectedAction === ACTION_SHIPMENT_REQUEST.APPROVED) {
      await this.doApprove();
    }
    this.handleSuccess();
  }

  async doReject() {
    this.$util.showLoading();
    try {
      await new ShipmentCertificatesApi().updateStatusShipmentCertificate({
        id: this.selectedID,
        action: ACTION_SHIPMENT_REQUEST.REJECTED,
        cancelRemarkShipmentCertificateRequest: {
          remark: this.remarkDialog
        }
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async doApprove() {
    this.$util.showLoading();
    try {
      await new ShipmentCertificatesApi().updateStatusShipmentCertificate({
        id: this.selectedID,
        action: ACTION_SHIPMENT_REQUEST.APPROVED,
        cancelRemarkShipmentCertificateRequest: {
          remark: this.remarkDialog
        }
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onChangeRequestWeight() {
    for (let index = 0; index < this.products.length; index++) {
      const product = this.products[ index ];
      product.validWeight = product.validWeightBak;
      product.inValidWeight = product.inValidWeightBak;
      const reqWeight = product.requestWeight ? Number(product.requestWeight) : 0;
      if (product.validWeightBak >= reqWeight) {
          product.validWeight = product.validWeightBak - reqWeight;
        } else {
          product.validWeight = 0;
          product.inValidWeight = product.inValidWeightBak + product.validWeightBak - reqWeight;
        }
    }
  }

  arrViewTreatmentId = [];
  showTreatmentBlock(treamentId) {
    this.arrViewTreatmentId.push(treamentId);
  }

  hideTreatmentBlock(treamentId) {
    this.arrViewTreatmentId = this.arrViewTreatmentId.filter(viewTreatmentId => viewTreatmentId !== treamentId);
  }

  onClickViewTreatmentId(treamentId) {
    const found = this.foundViewTreatmentId(treamentId);
    if (found) {
      this.hideTreatmentBlock(treamentId);
    } else {
      this.showTreatmentBlock(treamentId);
    }
  }

  foundViewTreatmentId(treamentId): boolean {
    return this.arrViewTreatmentId.includes(treamentId) || false;
  }
}
